// import React, { useState, useEffect } from "react"; 
// import axios from "../../api/axiosAuth";
// import io from "socket.io-client";
// import { useAuth } from "../../context/AuthContext";
// import '../../style/Publicaciones.css';

// export default function Publicaciones() {
//   const { token, user } = useAuth();
//  // Configuración de URLs apuntando al servidor AWS
// const API = process.env.REACT_APP_API || "http://3.236.217.225:5001/api";
// const SOCKET_URL = process.env.REACT_APP_SOCKET || "http://3.236.217.225:5001";
// const UPLOADS_URL = process.env.REACT_APP_UPLOADS || "http://3.236.217.225:5001";

//   const [feed, setFeed] = useState([]);
//   const [nuevoTexto, setNuevoTexto] = useState("");
//   const [imagen, setImagen] = useState(null);
//   const [cargando, setCargando] = useState(true);

//   // 🔁 Cargar feed completo del tenant
//   const cargarFeed = async () => {
//     if (!token || !user) return;

//     try {
//       const res = await axios.get(`${API}/publicaciones`, {
//         headers: { Authorization: `Bearer ${token}` },
//         params: { tenant_id: user.tenant_id },
//       });
//       setFeed(res.data || []);
//     } catch (err) {
//       console.error("❌ Error al cargar publicaciones:", err.response?.data || err.message);
//       setFeed([]);
//     } finally {
//       setCargando(false);
//     }
//   };

//   useEffect(() => { cargarFeed(); }, [user?.tenant_id]);

//   // 🔌 Socket tiempo real
//   useEffect(() => {
//     if (!token || !user) return;
//     const socket = io(SOCKET_URL, {
//       auth: { token, tenant_id: user.tenant_id },
//       transports: ["websocket"],
//     });

//     socket.on("post:created", (post) => {
//       if (post.tenant_id === user.tenant_id) {
//         setFeed((prev) => [post, ...prev]);
//       }
//     });

//     return () => socket.disconnect();
//   }, [token, user?.tenant_id]);

//   // 📝 Crear publicación
//   const crearPublicacion = async () => {
//     if (!nuevoTexto && !imagen) return;

//     const formData = new FormData();
//     formData.append("descripcion", nuevoTexto);
//     if (imagen) formData.append("imagen", imagen);

//     try {
//       await axios.post(`${API}/publicaciones`, formData, {
//         headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
//       });
//       setNuevoTexto("");
//       setImagen(null);
//     } catch (err) {
//       console.error("❌ Error al publicar:", err.response?.data || err.message);
//       alert("❌ Error al crear publicación");
//     }
//   };

//   const rolesPermitidos = ["rector", "coordinador", "secretario"];

//   if (cargando) return <p>⏳ Cargando publicaciones...</p>;

//   return (
//     <div className="max-w-3xl mx-auto p-4">
//       {rolesPermitidos.includes(user?.role) && (
//         <div className="mb-6 p-4 bg-white rounded-lg shadow-md publicar-box">
//           <h2 className="text-xl font-bold mb-2 text-gray-800">Crear Publicación</h2>
//           <textarea
//             className="w-full p-2 border rounded mb-2"
//             placeholder="Escribe algo..."
//             value={nuevoTexto}
//             onChange={(e) => setNuevoTexto(e.target.value)}
//           />
//           <input
//             type="file"
//             onChange={(e) => setImagen(e.target.files[0])}
//             className="mb-2"
//             accept="image/*"
//           />
//           <button
//             onClick={crearPublicacion}
//             className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
//           >
//             Publicar
//           </button>
//         </div>
//       )}

//       {feed.length ? feed.map((post) => (
//         <div key={post.id} className="mb-4 p-4 bg-white rounded-lg shadow-md post-card">
//           <div className="flex items-center mb-2">
//             <span className="font-bold text-gray-800">{post.nombre} {post.apellido} ({post.role})</span>
//             <span className="ml-2 text-gray-500 text-sm">{new Date(post.fecha_publicacion).toLocaleString()}</span>
//           </div>
//           {post.descripcion && <p className="mb-2 text-gray-700">{post.descripcion}</p>}
//           {post.imagen_url && <img src={encodeURI(`${UPLOADS_URL}${post.imagen_url}`)} alt="Publicación" className="w-full max-h-80 object-cover rounded mb-2" />}
//         </div>
//       )) : <p>No hay publicaciones aún.</p>}
//     </div>
//   );
// }



//

import React, { useState, useEffect, useCallback } from "react"; 
import axios from "../../api/axiosAuth";
import io from "socket.io-client";
import { useAuth } from "../../context/AuthContext";
import { API } from "../config"; // ✅ Importación centralizada
import '../../style/Publicaciones.css';

export default function Publicaciones() {
  const { token, user } = useAuth();

  // Configuración de URLs basada en la API centralizada
  const SOCKET_URL = API.replace('/api', ''); // Quita el /api para la conexión de socket
  const UPLOADS_URL = API.replace('/api', ''); // Base para las imágenes

  const [feed, setFeed] = useState([]);
  const [nuevoTexto, setNuevoTexto] = useState("");
  const [imagen, setImagen] = useState(null);
  const [preview, setPreview] = useState(null); // Para ver la imagen antes de subir
  const [cargando, setCargando] = useState(true);
  const [enviando, setEnviando] = useState(false);

  // 🔁 Cargar feed completo
  const cargarFeed = useCallback(async () => {
    if (!token || !user) return;

    try {
      const res = await axios.get(`${API}/publicaciones`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setFeed(Array.isArray(res.data) ? res.data : res.data?.data || []);
    } catch (err) {
      console.error("❌ Error al cargar publicaciones:", err);
      setFeed([]);
    } finally {
      setCargando(false);
    }
  }, [token, user]);

  useEffect(() => { 
    cargarFeed(); 
  }, [cargarFeed]);

  // 🔌 Socket en tiempo real
  useEffect(() => {
    if (!token || !user) return;

    const socket = io(SOCKET_URL, {
      auth: { token, tenant_id: user.tenant_id },
      transports: ["websocket"],
    });

    socket.on("post:created", (post) => {
      // Solo agregar si pertenece al mismo colegio (tenant)
      if (post.tenant_id === user.tenant_id) {
        setFeed((prev) => [post, ...prev]);
      }
    });

    return () => socket.disconnect();
  }, [token, user, SOCKET_URL]);

  // 🖼️ Manejar cambio de imagen
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImagen(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  // 📝 Crear publicación
  const crearPublicacion = async (e) => {
    e.preventDefault();
    if (!nuevoTexto && !imagen) return;

    const formData = new FormData();
    formData.append("descripcion", nuevoTexto);
    if (imagen) formData.append("imagen", imagen);

    setEnviando(true);
    try {
      await axios.post(`${API}/publicaciones`, formData, {
        headers: { 
          Authorization: `Bearer ${token}`, 
          "Content-Type": "multipart/form-data" 
        },
      });
      
      setNuevoTexto("");
      setImagen(null);
      setPreview(null);
      // No es necesario llamar a cargarFeed() si el socket está funcionando
    } catch (err) {
      console.error("❌ Error al publicar:", err);
      alert("❌ Error al crear publicación");
    } finally {
      setEnviando(false);
    }
  };

  const rolesPermitidos = ["rector", "coordinador", "secretario"];

  if (cargando) return (
    <div className="flex-center p-10">
      <div className="spinner"></div>
      <p>⏳ Cargando muro de noticias...</p>
    </div>
  );

  return (
    <div className="publicaciones-container">
      {/* SECCIÓN CREAR (Solo personal autorizado) */}
      {rolesPermitidos.includes(user?.role) && (
        <div className="publicar-card animate-in">
          <h3>📢 Crear Comunicación</h3>
          <form onSubmit={crearPublicacion}>
            <textarea
              placeholder={`¿Qué quieres informar hoy, ${user.nombre}?`}
              value={nuevoTexto}
              onChange={(e) => setNuevoTexto(e.target.value)}
              required={!imagen}
            />
            
            {preview && (
              <div className="image-preview">
                <img src={preview} alt="Vista previa" />
                <button type="button" onClick={() => { setImagen(null); setPreview(null); }}>✕</button>
              </div>
            )}

            <div className="form-actions">
              <label className="btn-file">
                📷 Adjuntar Imagen
                <input type="file" onChange={handleImageChange} accept="image/*" />
              </label>
              <button 
                type="submit" 
                className="btn-publicar" 
                disabled={enviando}
              >
                {enviando ? "Enviando..." : "Publicar ahora"}
              </button>
            </div>
          </form>
        </div>
      )}

      {/* FEED DE PUBLICACIONES */}
      <div className="feed">
        {feed.length > 0 ? (
          feed.map((post) => (
            <div key={post.id} className="post-card animate-in">
              <div className="post-header">
                <div className="avatar-fake">
                  {post.nombre?.charAt(0)}{post.apellido?.charAt(0)}
                </div>
                <div className="post-info">
                  <span className="user-name">
                    {post.nombre} {post.apellido}
                  </span>
                  <span className="user-role badge-role">{post.role}</span>
                  <span className="post-date">
                    {new Date(post.fecha_publicacion).toLocaleString('es-CO', { 
                      day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' 
                    })}
                  </span>
                </div>
              </div>

              <div className="post-content">
                {post.descripcion && <p>{post.descripcion}</p>}
                {post.imagen_url && (
                  <div className="post-image-wrapper">
                    <img 
                      src={`${UPLOADS_URL}${post.imagen_url}`} 
                      alt="Comunicado" 
                      loading="lazy"
                    />
                  </div>
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="no-posts">
            <p>📭 No hay publicaciones en este momento.</p>
          </div>
        )}
      </div>
    </div>
  );
}